import {
  IconExclamationTriangleOutline,
  IconFileWithItemsOutline,
} from '@iwoca/icons';

import styles from './FileStatusSections.module.css';
import { TFile } from '../../../../../hooks/useFileUploadReducer';
import UploadedFiles from '../../../UploadedFiles/UploadedFiles';

type TFilesByStatus = {
  uploaded: TFile[];
  rejected: TFile[];
};

const groupFilesByStatus = (files: TFile[]): TFilesByStatus => {
  return files.reduce<TFilesByStatus>(
    (acc, file) => {
      if (file.status === 'error' || file.status === 'rejected') {
        acc.rejected.push(file);
      } else if (file.status !== 'loading') {
        acc.uploaded.push(file);
      }
      return acc;
    },
    { uploaded: [], rejected: [] },
  );
};

type TProps = {
  files: TFile[];
  removeFile: (id: string) => void;
};

const FileStatusSections = ({ files, removeFile }: TProps) => {
  const groupedFiles = groupFilesByStatus(files);
  const hasUploadedFiles = groupedFiles.uploaded.length > 0;
  const hasRejectedFiles = groupedFiles.rejected.length > 0;

  if (!hasUploadedFiles && !hasRejectedFiles) {
    return null;
  }

  return (
    <>
      {hasUploadedFiles && (
        <div className={styles.uploadedSection}>
          <div className={styles.filesList}>
            <UploadedFiles
              files={groupedFiles.uploaded}
              removeFile={removeFile}
            />
          </div>
          <div className={styles.sectionLabel}>
            <IconFileWithItemsOutline className={styles.uploadedIcon} />
            <p>Documents uploaded</p>
          </div>
        </div>
      )}

      {hasRejectedFiles && (
        <div className={styles.rejectedSection}>
          <div className={styles.filesList}>
            <UploadedFiles
              files={groupedFiles.rejected}
              removeFile={removeFile}
            />
          </div>
          <div className={styles.sectionLabelRejected}>
            <IconExclamationTriangleOutline className={styles.rejectedIcon} />
            <p>Documents rejected</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FileStatusSections;
